<template>
<div>
    <div v-if="ie=='i'">
        <!-- 多哥(TGO)进口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th>进口港</th>
                        <td colspan="3">{{billInfo.UnLoadingPort}}</td>
                    </tr>
                    <tr>
                        <th width="25%">进口国</th>
                        <td width="25%">{{billInfo.ImporterCountry}}</td>
                        <th width="25%">进口国家码</th>
                        <td width="25%">{{billInfo.ImporterCountryCode}}</td>
                    </tr>
                    <tr>
                        <th>进口FOB金额</th>
                        <td>{{billInfo.Value}}</td>
                        <th>进口CIF金额</th>
                        <td>{{billInfo.TotalCif}}</td>
                    </tr>
                    <tr>
                        <th>出发港</th>
                        <td>{{billInfo.LoadingPort}}</td>
                        <th>出口国</th>
                        <td>{{billInfo.ShipperCountry}}</td>
                    </tr>
                    <tr>
                        <th>Hs编码描述</th>
                        <td>{{billInfo.HsDescription}}</td>
                        <th>原产国</th>
                        <td>{{billInfo.Country}}</td>
                    </tr>
                    <tr>
                        <th>单价</th>
                        <td>{{billInfo.Price}}</td>
                        <th>数量单位</th>
                        <td>{{billInfo.QuantityUnit}}</td>
                    </tr>
                    <tr>
                        <th>货币单位</th>
                        <td>{{billInfo.Currency}}</td>
                        <th>净重</th>
                        <td>{{billInfo.NetWeight}}</td>
                    </tr>
                    <tr>
                        <th>净重单位</th>
                        <td>{{billInfo.NetWeightUnit}}</td>
                        <th>毛重单位</th>
                        <td>{{billInfo.WeightUnit}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
    <div v-if="ie=='e'">
        <!-- 多哥(TGO)出口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th>进口港</th>
                        <td colspan="3">{{billInfo.UnLoadingPort}}</td>
                    </tr>
                    <tr>
                        <th width="25%">进口国</th>
                        <td width="25%">{{billInfo.ImporterCountry}}</td>
                        <th width="25%">进口国家码</th>
                        <td width="25%">{{billInfo.ImporterCountryCode}}</td>
                    </tr>
                    <tr>
                        <th>进口FOB金额</th>
                        <td>{{billInfo.Value}}</td>
                        <th>进口CIF金额</th>
                        <td>{{billInfo.TotalCif}}</td>
                    </tr>
                    <tr>
                        <th>出发港</th>
                        <td>{{billInfo.LoadingPort}}</td>
                        <th>出口国</th>
                        <td>{{billInfo.ShipperCountry}}</td>
                    </tr>
                    <tr>
                        <th>Hs编码描述</th>
                        <td>{{billInfo.HsDescription}}</td>
                        <th>原产国</th>
                        <td>{{billInfo.Country}}</td>
                    </tr>
                    <tr>
                        <th>单价</th>
                        <td>{{billInfo.Price}}</td>
                        <th>数量单位</th>
                        <td>{{billInfo.QuantityUnit}}</td>
                    </tr>
                    <tr>
                        <th>货币单位</th>
                        <td>{{billInfo.Currency}}</td>
                        <th>净重</th>
                        <td>{{billInfo.NetWeight}}</td>
                    </tr>
                    <tr>
                        <th>净重单位</th>
                        <td>{{billInfo.NetWeightUnit}}</td>
                        <th>毛重单位</th>
                        <td>{{billInfo.WeightUnit}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
</div>
</template>

<script>
export default {
    props:["billInfo","ie"],
    data() {
        return {

        };
    },
    methods: {

    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.partItem {
    margin-bottom: 20px;
    ::v-deep .el-card__header {
        padding: 10px 20px;
        .headTitle {
            display: inline-block;
            padding-left: 10px;
            font-size: 14px;
            border-left: 2px solid var(--themeColor);
            font-weight: bold;
        }
    }
}
table {
    width: 100%;
    border-collapse: collapse;
    tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
        th,
        td {
            font-size: 12px;
            color: #666;
            height: 40px;
            border: 1px solid #eaeaea;
            text-align: center;
        }
        th {
            background-color: #f5f7fa;
            font-weight: 700;
        }
        .bg {
            background-color: var(--themeColor);
            color: #fff;
            font-weight: 700;
            opacity: 0.8;
        }
    }
}
</style>